export default __webpack_public_path__ + "static/abovefooterbrush-4c7f6df6cc612bda39319344981c14cf.png";